<template>
  <div class="b-wallet">
    <div class="b-wallet__desk">
      <ul  v-for="(wallet, index) in items" :key="index">
        <li>         
          <a :href="wallet.ios.url">
            <img
              :src="wallet.ios.img"
              alt="apple-wallet" />
          </a>
        </li>
        <li>
          <a :href="wallet.android.url">
            <img
              :src="wallet.android.img"
              alt="google-wallet" />
          </a>
        </li>
      </ul>
    </div>

    <div class="b-wallet__mob">
      <ul v-for="(wallet, index) in items" :key="index">
        <li class="b-wallet__mob__ios hide">
          <a :href="wallet.ios.url">
            <img
              :src="wallet.ios.img"
              alt="apple-wallet" />
          </a>
        </li>
        <li class="b-wallet__mob__android hide">
          <a :href="wallet.android.url">
            <img
              :src="wallet.android.img"
              alt="google-wallet" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import Wallet from '../../modules/w-wallet';
export default {
  props: {
    items: {
      default() {
        return []
      },
      type: Array,
    },
  },
  mounted() {
    this.initWallet()
  },
  methods:{
    initWallet(){
      this.$nextTick(()=>{
        new Wallet(jQuery(".b-wallet"))
       
      })
     
    }
  }
}
</script>
